import { inline, shift, offset, flip } from '@floating-ui/core'
import { autoUpdate } from '@floating-ui/dom'
import { useFloating } from '@floating-ui/react-dom'
import { FloatingPortal } from '@floating-ui/react-dom-interactions'
import { FC, useEffect } from 'react'
import Styles from './FloatingDropdown.module.scss'

interface Props {
  anchor: Element | null
  root?: HTMLElement | null | undefined
}

export const FloatingDropdown: FC<React.PropsWithChildren<Props>> = ({ children, anchor, root }) => {
  const { x, y, reference, floating } = useFloating({
    placement: 'bottom-start',
    strategy: 'fixed',
    middleware: [offset(4), inline(), flip(), shift({ padding: 4 })],
    whileElementsMounted: (reference, floating, update) => {
      return autoUpdate(reference, floating, update, {
        animationFrame: true,
      })
    },
  })

  useEffect(() => {
    if (anchor) {
      reference(anchor)
    }
  }, [anchor, reference])

  return (
    <FloatingPortal id="floating-ui-root" root={root}>
      <div
        ref={floating}
        className={Styles.floatingDropdown}
        style={{ top: y || 0, left: x || 0 }}
        data-skip-blur="true"
      >
        {children}
      </div>
    </FloatingPortal>
  )
}
